module.exports = __webpack_public_path__ + "img/799395b.svg";